<template>
  <v-row>
    <v-col class="primary--text">
      <span class="pointer" @click="back()"
        ><span class="display-22 primary--text mx-3">
          <v-icon color="primary" class="display-24 ml-2">
            mdi-arrow-right</v-icon
          >שלב קודם</span
        >
      </span>
    </v-col>
  </v-row>
</template>

<script>
export default {
  components: {},
  methods: {
    back() {
      let page = `/קורות-חיים/${this.$route.params.id - 1}/`
      this.$router.push(page)
    },
  },
}
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 600px) {
}
</style>
